<template>
    <div>
  <top-navbar></top-navbar>
  <div class="mb-5 background_color" >
      <!-- <h4 class="manage-boder">Manage Customer</h4>  -->
      <h6 class="manage-boder pt-2 font1  decoration">  <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Vehicles</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" >Sales</a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> Manage Proforma Invoice  </h6>

      <div class="container-fluid">
      <div style="border: 0px; padding: 0px; min-height:0px" class="navbar background_color">

        <div class="d-flex">
            <b-input-group size="sm" style="width: 225px;">
              <b-form-input id="filter-input" v-model="filter" @input="loadMiinventory()" type="search" placeholder="Search">
              </b-form-input>
            </b-input-group>

            <div class="ms-2" style="position: relative;">
              <b-input-group style="width: 225px;">
                <!-- <b-form-input type="date" v-model="FromDate" placeholder="" ref="fromDateInput"></b-form-input> -->
                <DatePicker 
                  v-model="FromDate"
               @input="loadMiinventory()"
                  placeholder="From Date"
                  ref="fromDateInput"
                  style=""
                
                />
              
              </b-input-group>
            </div>
            <div class="" style="position: relative;">
              <b-input-group size="sm" style="width: 225px;">
               
                <DatePicker
                  v-model="ToDate"
               @input="loadMiinventory()"
                  placeholder="To Date"
                  ref="fromDateInput"
                />
              
              </b-input-group>
            </div>

    <div style="margin-top: 11px;" class="ms-2" >
    <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
  </div>

        </div>
    

      <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

        <!-- <button  @click="CreateSale()"  class="btn btn-outline-primary btn-sm mb-1 me-0 mt-0">  Create Sales Contact</button> -->
      
     

        <div>
  <b-modal :id="infoModal1.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      
     bottom>
    <template   #modal-title>
     
      <h3 >Confirm !</h3>

      
  
    </template>
    
    <div class="d-block text-center">
      <h5>Are you sure you want to Confirm this item?</h5>
    </div>
    <hr>
    
    <template   #modal-footer>
    <button style="font-size: small;" @click="Confirm(infoModal1.content)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">Yes</button>
    <button style="font-size: small;" @click="$bvModal.hide(infoModal1.id)" class="mr-1 btn btn-outline-primary btn-sm mb-1 bdr-rad">No</button>
    </template>

  
  </b-modal>

 
</div>
  
      </div>
    </div>
    <div class="card bdr-rad2 mt-1 shadow p-2">
    <div class="card-body " >
<div class="d-flex justify-content-center" v-if="isLoading">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
<div v-else>


       <!-- <div style="border: 0px; padding: 0px; min-height:20px" class="navbar">
    
    <div class="d-flex  ">
    
    </div>
    <div class="d-flex  ">
      <span class="custom-breadcrumb"><b>Showing {{currentPage}}-{{currentPage*perPage}} of {{totalRows}} items.</b></span>
    </div>
    </div> -->
   
  <div class="table-responsive">
   

    <b-table responsive style="font-size: small;"  class=" table-hover "
      :items="all_datas"
      :fields="fields"
      :current-page="currentPage"
      head-variant="dark"
    
      :filter="filter"
      :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      
      
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
  
      show-empty
      small
   
    >
   

]
      <template #cell(actions)="row">
        <div class="dropdown">
  <button class="btn btn-sm btn-outline-primary dropdown-toggle bdr-rad" type="button" data-toggle="dropdown" aria-expanded="false">
    Action
  </button>
  <div class="dropdown-menu bdr-rad">
    <a class="dropdown-item mouse-cursor" @click="moreinfo(row.item.id)">View</a>
    <a class="dropdown-item mouse-cursor"   @click="Update(row.item.id)" v-if="row.item.statusvalue==1">Update</a>
    <a class="dropdown-item mouse-cursor"  @click="Confimmodel(row.item.id)" v-if="row.item.statusvalue==1">Confirm</a>
    <a class="dropdown-item mouse-cursor"  @click="Createso(row.item.id)" v-if="row.item.statusvalue==3">Create SO</a>
    <a class="dropdown-item mouse-cursor"  v-if="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)" >Print</a>
   
  </div>
</div>
     
        <!-- <button  style=" font-size: small;"
         @click="moreinfo(row.item.id)" class="mr-1 btn   btn-outline-primary btn-sm mb-1 bdr-rad">
          View
        </button>
      
        <button  style=" font-size: small;"
         @click="Update(row.item.id)" v-if="row.item.statusvalue==1" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Update
        </button>
        <button  style=" font-size: small;"
         @click="Confimmodel(row.item.id)" v-if="row.item.statusvalue==1" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Confirm
        </button>
        <button  style=" font-size: small;"
         @click="Createso(row.item.id)" v-if="row.item.statusvalue==3" class="mr-1 btn  btn-outline-primary btn-sm mb-1 bdr-rad">
         Create SO
        </button>
        <button v-if="row.item.statusvalue!=1"  @click="generatePDF(row.item.id)"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Print</button> -->
      </template>

      <template #cell(number)="row">
                 {{ row.index + 1 === 10 ? currentPage * 10 : (currentPage - 1)*10 + row.index + 1 }} 
                  </template>
      <template #cell(P_code1)="row">
       <a href="/" > {{ row.item.P_code }}</a>
</template>

     
    </b-table>



    <b-col style="padding-left: 0px;" sm="7" md="2" class="my-1 mb-4">
      <b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" size="sm"></b-pagination>
    </b-col>

  </div>

  </div>
 
  <b-modal   :id="infoModal.id" :title="infoModal.content.C_code"  hide-footer >
    <div class="card">
      <div class="card-body">


        <table style="font-size: small; " class="table  table-sm  ">
       
          <tbody >
   
            <tr >
              <td style="border: 0px;" ><b>Id </b></td>
             <td style="border: 0px;">{{ infoModal.content.idCustomer }}</td> 
            </tr>
            <tr>
              <td><b>Name of Homeowner </b></td>
             <td>{{ infoModal.content.C_name }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 1 </b></td>
             <td>{{ infoModal.content.C_address_line1 }}</td> 
            </tr>
           
            <tr>
              <td><b>Address Line 2 </b></td>
             <td>{{ infoModal.content.C_address_line2 }}</td> 
            </tr>
            <tr>
              <td><b>Address Line 3 </b></td>
             <td>{{ infoModal.content.C_address_line3 }}</td> 
            </tr>
            <tr>
              <td><b>Apt Phone </b></td>
             <td>{{ infoModal.content.C_contact_tel1 }}</td> 
            </tr>
            <tr>
              <td><b>Service charge/<br> Sinking fund </b></td>
             <td>{{ infoModal.content.billing_type }}</td> 
            </tr>
            <tr>
              <td><b>Created Date </b></td>
             <td>{{ infoModal.content.C_created_date }}</td> 
            </tr>
           
             
          </tbody>
   
   
        </table>

      </div>
    </div>

  </b-modal>
  
  
  </div>
    </div>

    <br><br>
  </div>
  </div>

  <content-footer></content-footer>
</div>
  
  
  </template>
  
  <script>
   import jsPDF from 'jspdf';
   import 'jspdf-autotable';
   import axios from 'axios';
   import authService from '@/auth.service';
   import TopNavbar from './../../layout/TopNavbar.vue';
   import ContentFooter from './../../layout/ContentFooter.vue'
   import DatePicker from 'vue2-datepicker';
   import 'vue2-datepicker/index.css';
  
  
  
  export default {
    components :{
       
        TopNavbar,
        ContentFooter,
        DatePicker, 
    },
  
      mounted(){
    this.loadMiinventory()
      },
     
      computed: {
        
  
  
  
      },
  
      data(){
      return{
        isModalOpen: false,
        all_datas:[],
        all_data1:{},
        total:{},
        details:[],
      search: "",
      access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        FromDate: null,
        ToDate: null,
        filterOn: [],
        quatations1: {},
        totalRows: 1,
        currentPage: 1,
        perPage:15,
        pageOptions: [5, 10, 15, { value: 100, text: "Show a lot" }],
       
        fields: [
          { key: 'number', label: '#', sortable: true, sortDirection: 'desc' },
          { key: 'pfi_code', label: 'PFI Code', sortable: true,  },
          { key: 'user_full_name', label: 'Customer', sortable: true  },
          { key: 'issue_date', label: 'Issue Date', sortable: true  },
          { key: 'name1', label: 'Sales Rep', sortable: true  },
        //   { key: 'address', label: 'Customer Contact No.', sortable: true  },
          { key: 'remarks', label: 'Remarks', sortable: true  },
          { key: 'status', label: 'Status	', sortable: true ,  },
          { key: 'created_date', label: 'Created Date', sortable: true ,  },
         
     
       //   { key: 'status', label: 'Status', sortable: true ,  },
               
          
          { key: 'actions', label: 'Actions', class:'width-custom3', }
        ],
          
        infoModal: {
          id: 'info-modal',
          title: '',
          content: {},
        },
        infoModal1: {
          id: 'info-modal1',
          title: '',
          content: {},
        },
        isLoading: true, 
        variants: ['primary', 'secondary', 'success', 'warning', 'danger', 'info', 'light', 'dark','mycoolor'],
        headerBgVariant: 'mycoolor',
        headerTextVariant: 'light',
       
       
      };
      },
  
      
  
  
     methods:{ 



      async generatePDF(id) {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/spfi/view?id='+id,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_data1 = data.all_data
         this.details = data.details
        //  this.details = data.details
        this.total = data.total

        
      } catch (error) {
        console.log(error.response);
      }

 
    
    const doc = new jsPDF();

    function addPageBorders(doc) {
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;

  // Set the border style
  doc.setDrawColor(71, 144, 255); // Black color
  doc.setLineWidth(15); // Border width

  // Draw a line at the top of the page
  doc.line(0, 0, pageWidth, 0);
  // Draw a line at the bottom of the page
  doc.line(0, pageHeight, pageWidth, pageHeight);
}
   // Update this with your image URL or file path
 
    var img = new Image()
  img.src = '/img/evenware-logo.png'
  const imageWidth = doc.internal.pageSize.getWidth() - 550; // Adjust 20 if you need margins
const imageHeight = (imageWidth * 3) / 4; // Assuming the aspect ratio is 4:3, adjust as needed

doc.addImage(img, 'png', 10, 13, imageWidth, imageHeight);
doc.setFontSize(18);
doc.setFont('Helvetica', 'bold');
doc.text('PROFORMA', 105, 30, null, null, 'center');
doc.setFontSize(12);

doc.text('Demonstration System', 10, 45, null, null);

doc.setFont('Helvetica', 'normal');
doc.setFontSize(8);
doc.text('No 08, Rodrigo Mawatha,', 10, 48, null, null);
doc.text('Nawala Road,', 10, 51, null, null);
doc.text('Rajagiriya,', 10, 54, null, null);
doc.text('Colombo 08,', 10, 57, null, null);
doc.text('Sri Lanka', 10, 60, null, null);
doc.text('Tel : 0112 806 776-9,', 10, 63, null, null);
doc.text('Web : colombo@cmc.slt.lk ,', 10, 66, null, null);


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('PROFORMA To:', 85, 45, null, null);
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.relatedToCustomer.user_full_name, 85, 48, null, null);
doc.text(this.all_data1.relatedToCustomer.user_address_line1, 85, 51, null, null);









doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('PFI Code:', 200, 45, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.pfi_code, 200, 49, null, null, 'right');


doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Sales Person:', 200, 53, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.relatedToRep.name, 200, 56, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Dealer:', 200, 60, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.relatedToDealer.C_name, 200, 63, null, null, 'right');

doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Validity Period:', 200, 67, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.validity_period, 200, 70, null, null, 'right');




doc.setFontSize(10);
doc.setFont('Helvetica', 'bold');
doc.text('Date:', 200, 74, null, null, 'right');
doc.setFontSize(8);
doc.setFont('Helvetica', 'normal');
doc.text(this.all_data1.issue_date, 200, 77, null, null, 'right');

const tableData = [
      ['No', 'DESCRIPTION', 'UNIT PRICE', 'TOTAL AMOUNT']
  ];



  

  this.details.forEach(detail => {
      tableData.push([
          detail.no,
         detail.description,
           detail.customer_price, 
         
       
            detail.customer_price, 
         
         
        
      ]);
  });



// Use jsPDF and autoTable


      // Add table to the PDF
      doc.autoTable({
          startY: 85, // Y position to start the table
          head: [tableData[0]], // Table header
          body: tableData.slice(1),
          addPageContent: function(data) {
      addPageBorders(doc); // Call the function to add page borders
  },
  styles: {
      font: 'Helvetica',
      fontSize:8,
  },
          // Table data excluding header
      });

      
      const tableBottomY = doc.lastAutoTable.finalY;

      doc.setFontSize(8);
      doc.setFont('Helvetica', 'bold');
      doc.text('Sub Total: '+this.total, 195, tableBottomY+10, null, null, 'right');

      // doc.setFontSize(8);
      // doc.setFont('Helvetica', 'bold');
      // doc.text('Special Discount: '+this.total.special_discount, 195, tableBottomY+18, null, null, 'right');

      // doc.setFontSize(8);
      // doc.setFont('Helvetica', 'bold');
      // doc.text('Total :'+this.total.sub_total, 195, tableBottomY+26, null, null, 'right');

      doc.setFontSize(9);
      doc.setFont('Helvetica', 'normal');
      doc.text('* Cheques should be drawn in favour of “JANATHA AUTOMOBILES (PVT) LTD” & crossed A/C payee only.', 10, tableBottomY+45, null, null);
      doc.text('* Settlement should be made within 5 days', 10, tableBottomY+50, null, null);
      doc.text('* Any complaints should be informed within 3 days after receiving the goods.', 10, tableBottomY+55, null, null);
      doc.text('* Complaints after 3 days will not be accepted under any circumstances.', 10, tableBottomY+60, null, null);
      doc.text('* Bank Details : Commercial Bank (7056), Old Moor Street Branch (017), A/C No. 100 039 2638. ', 10, tableBottomY+65, null, null);
      doc.text('* The above Invoice is inclusive of all taxes.', 10, tableBottomY+70, null, null);
      



      doc.output('dataurlnewwindow');



  },






  
      async info(idCustomer) {
    console.log(idCustomer);
    try {
      const { data} = await  axios.get('/mcustomer/view?id='+idCustomer,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.infoModal.content = data.item_list
       this.$root.$emit('bv::show::modal', this.infoModal.id)
      
      
    } catch (error) {
      console.log(error.response);
    }
  },

  async moreinfo(id) {
  
    this.$router.push('/spfi/view?id='+id);
   
  },
  async CreateSale() {
  
    this.$router.push('/sopportunity/create');
   
  },
 
  async Createso(id){
        this.$router.push('/svehiclesalesorder/create?id='+id);
      },
  async Update(id){
        this.$router.push('/spfi/update?id='+id);
      },

      async Confimmodel(id){
        this.infoModal1.content = id;
       this.$root.$emit('bv::show::modal', this.infoModal1.id);
      
      },
  
      serchCustom(id) {

    this.filterOn = id;
    },

    // onFiltered(filteredItems) {
    //     // Trigger pagination to update the number of buttons/pages due to filtering
    //     this.totalRows = filteredItems.length
    //     this.currentPage = 1
    //   },
  
    async loadMiinventory(page = this.currentPage) {
       
    
      try {
        const { data} = await  axios.get('/spfi/index',{

          params: {
            page: page,
            perPage: this.perPage,
            filter: this.filter,
            FromDate: this.FromDate,
            ToDate: this.ToDate,
          },
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.all_datas = data.all_data;
        this.totalRows = data.total_count;
        this.currentPage = data.page;
        this.isLoading = false;
        
      } catch (error) {
        console.log(error.response);
      }
    },

    pageChanged(page) {
     
     this.loadMiinventory(page);
 },

    async Confirm(id) {
      
    
       try {
         const { data} = await  axios.get('/spfi/confirm?id='+id,{
           headers:{
             'Authorization':'Bearer '+this.access_token,
             'Content-type': 'application/json',
            
           }
          });
          console.log(data);
          if(data.status==200){
            this.loadMiinventory();
           
            this.$root.$emit('bv::hide::modal', this.infoModal1.id);
        }
         
       } catch (error) {
         console.log(error.response);
       }
     },
     
  
   
  
  
  
  
  
  }
  
  
  
  
  };
  
  </script>
  
  <style >


  .button1{
    width: 10px !important;
  }
  .border1{
    border: none;
    background-color: #0d6efd;
  }
  .font-color1:hover{
    color: black !important;
    cursor: pointer;
  }
  .manage-boder{
    border-bottom: 1px solid #E9E9E3;
    border-top: 1px solid #E9E9E3;
  }
  .border-radius0{
        border-radius:0px !important ;
  }
  .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold;
      }
      .manage-boder{
      border-bottom: 2px solid #E9E9E3;
      border-top: 2px solid #E9E9E3;
      padding-bottom: 10px !important;
      padding-top: 10px !important;
      
      }
      .font1{
        font-size: 13px !important;
     
      }
      .font-bold1{
        font-weight: bold !important;
      }
      .colr1{
          color:#A5A5A3;
          
      }
      .decoration{
      text-decoration: none;
      color:#A5A5A3  ;
    }
    .width7{
      width: 250px;
    }
    .bg-mycoolor{
      background-color: #a4d2f3 !important;

    }
   
  .modal-footer{
    text-align: right !important;
    display: block;
  }
  
  </style>